// Breadcrumb.js
import React from "react";

/**
 * segments: Array<{ label: string, onClick?: () => void, className?: string }>
 */
export default function Breadcrumb({ segments = [] }) {
  if (!Array.isArray(segments) || segments.length === 0) return null;

  return (
    <nav className="nr-breadcrumb" aria-label="Breadcrumb">
      <ol className="nr-breadcrumb__list">
        {segments.map((seg, idx) => {
          const isLast = idx === segments.length - 1;
          const label = seg?.label ?? "";
          const isHome = idx === 0;

          const liClass = [
            "nr-breadcrumb__item",
            isLast ? "is-current" : "",
            seg?.className || ""
          ]
            .filter(Boolean)
            .join(" ");

          // Add a dedicated class to the element (link/label) for HOME
          const elemClass = [
            isHome ? "nr-breadcrumb__home" : "",         // <<-- only first crumb
            isLast ? "nr-breadcrumb__label" : "nr-breadcrumb__link"
          ]
            .filter(Boolean)
            .join(" ");

          return (
            <li key={`${label}-${idx}`} className={liClass}>
              {isLast || !seg?.onClick ? (
                <span
                  className={elemClass}
                  aria-current={isLast ? "page" : undefined}
                  title={label}
                >
                  {label}
                </span>
              ) : (
                <button
                  type="button"
                  className={elemClass}
                  onClick={seg.onClick}
                  title={label}
                >
                  {label}
                </button>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

